import React, { useState, useEffect } from "react";
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import api from "../../services/api";
import { toast } from "react-toastify";

const initialTag = {
  name: "",
  color: "#ffffff",
  description: "",
  isGroup: false,
  parentId: "",
};

const TagModal = ({ open, onClose, tagId, defaultIsGroup = false }) => {
  const [tag, setTag] = useState(initialTag);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;

    (async () => {
      try {
        const { data: tags } = await api.get("/tags");
        setGroups(tags.filter((item) => item.isGroup && item.id !== tagId));

        if (tagId) {
          const { data } = await api.get(`/tags/${tagId}`);
          setTag({
            name: data.name || "",
            color: data.color || "#ffffff",
            description: data.description || "",
            isGroup: Boolean(data.isGroup),
            parentId: data.parentId || "",
          });
          return;
        }

        setTag({ ...initialTag, isGroup: defaultIsGroup });
      } catch (err) {
        toast.error("Erro ao carregar etiqueta");
      }
    })();
  }, [tagId, open, defaultIsGroup]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        ...tag,
        parentId: tag.isGroup ? null : tag.parentId || null,
      };

      if (tagId) {
        await api.put(`/tags/${tagId}`, payload);
      } else {
        await api.post("/tags", payload);
      }
      toast.success("Salvo com sucesso!");
      onClose();
    } catch (err) {
      toast.error("Erro ao salvar etiqueta");
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{tagId ? "Editar Etiqueta" : "Nova Etiqueta"}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={tag.isGroup}
                onChange={(e) =>
                  setTag({ ...tag, isGroup: e.target.checked, parentId: "" })
                }
              />
            }
            label="Grupo de etiquetas"
          />

          <TextField
            label="Nome"
            variant="outlined"
            fullWidth
            required
            value={tag.name}
            onChange={(e) => setTag({ ...tag, name: e.target.value })}
            margin="dense"
          />

          {!tag.isGroup && (
            <FormControl variant="outlined" fullWidth margin="dense">
              <InputLabel>Grupo</InputLabel>
              <Select
                value={tag.parentId || ""}
                onChange={(e) => setTag({ ...tag, parentId: e.target.value })}
                label="Grupo"
              >
                <MenuItem value="">Sem grupo</MenuItem>
                {groups.map((group) => (
                  <MenuItem key={group.id} value={group.id}>
                    {group.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          <TextField
            label="Descrição"
            variant="outlined"
            fullWidth
            multiline
            rows={3}
            value={tag.description}
            onChange={(e) => setTag({ ...tag, description: e.target.value })}
            margin="dense"
          />

          <TextField
            label="Cor"
            type="color"
            variant="outlined"
            fullWidth
            value={tag.color}
            onChange={(e) => setTag({ ...tag, color: e.target.value })}
            margin="dense"
            style={{ marginTop: 15 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary" disabled={loading}>
            Cancelar
          </Button>
          <Button type="submit" color="primary" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : "Salvar"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default TagModal;
